import React, {useEffect, useRef, useState} from 'react';
import {AppEnv} from '../../env';
import {Col, Row} from 'react-material-responsive-grid';
import {confirmAlert} from 'react-confirm-alert';
import 'react-responsive-modal/styles.css';
import {
    alertFail,
    alertWarning,
    checkDniLength,
    customAlertResp,
    pulseLoader,
    validateDni,
    whatsAppMessage
} from "../../Global-W/NewFunctions";
import axios from "axios"
import GlobalConfigurationContext from "../../../Context/GlobalConfigurationContext";
import OwnModal from "../../Global-W/Hooks/Modal";
import FaltaMensaje from "../../Global-W/Classes/FaltaMensaje";
import {Modal} from "react-responsive-modal";

const moment = require('moment');
require('moment/locale/es');
moment.locale('es');

export default function Preinscrip({dataSchool, globals}) {
    const [addAspirant, setAddAspirant] = useState(false);
    const [elGeneroTut, setElGeneroTut] = useState('')
    const [nombre, setNombre] = useState('')
    const [apellido_materno, setApellido_materno] = useState('')
    const [apellido_paterno, setApellido_paterno] = useState('')
    const [numero_tel, setNumero_tel] = useState('')
    const [email, setEmail] = useState('')
    const [listSteps, setListSteps] = useState([])
    const [indicator, setIndicator] = useState(true)
    const [calle, setCalle] = useState('')
    const [numero, setNumero] = useState('')
    const [codigo_postal, setCodigo_postal] = useState('')
    const [colonia, setColonia] = useState('')
    const [ciudad, setCiudad] = useState('');
    const [estado, setEstado] = useState('');
    const [datosTutor, setDatosTutor] = useState([]);
    const [hermanos, setHermanos] = useState([]);
    const [curpTutor, setCurpTutor] = useState('')
    const [losAspirantes, setLosAspirantes] = useState({
        curp_aspirante: '',
        email_aspirante: '',
        tipo_alta: '',
        id_ciclo: '',
        identificacion_estudiante: ''
    })
    const [ciclosBtn, setCiclosBtn] = useState([])
    const [visible, setVisible] = useState(false);
    const [grados, setgrados] = useState([])
    const [elCiclo, setElCiclo] = useState('')
    const [laEscuela, setLaEscuela] = useState('')
    const [elNivel, setElNivel] = useState('')
    const [ixSelectG, setIxSelectG] = useState(-1)
    const [indicatorCiclo, setIndicatorCiclo] = useState(false)
    const [losMedios, setLosMedios] = useState([])
    const [elMedio, setElMedio] = useState('')
    const [indicatorNext, setIndicatorNext] = useState(false)
    const [modalPdf, setModalPdf] = useState(false);
    const [numberWhatsapp, setNumberWhatsapp] = useState('')
    const [soporteEscuelaCheck, setSoporteEscuelaCheck] = useState(false)
    const [soporteKolegiaCheck, setSoporteKolegiaCheck] = useState(false)
    const [datosAdicionales, setDatosAdicionales] = useState(false)
    const [inputsAdicionales, setInputsAdicionales] = useState(false)
    const [modalBrothers, setModalBrothers] = useState(false)
    const [requireEmail, setRequireEmail] = useState(false)
    const [nombreHermano, setNombreHermano] = useState('')
    const [turnoHermano, setTurnoHermano] = useState('');
    const [nombreCiclo, setNombreCiclo] = useState('')
    const [indexCiclo, setIndexCiclo] = useState(0);
    const [emailAddres, setEmaiAddres] = useState('');
    const [disabledButton, setDisabledButton] = useState(false);

    const curpInput = useRef(null);
    const curpAspInput = useRef(null)
    const [bd, setBd] = useState('')
    const [idSchool, setIdSchool] = useState('')

    const confApellidoMaterno = globals.apellido_materno;
    const country = dataSchool.id_pais;
    const aliasIdCiudadano = globals.alias_id_ciudadano;
    const elLogoAdmin = 'https://galeriasce.s3-us-west-2.amazonaws.com/img-repos/' + bd + '/logo_preinscripcion.png';
    const icono = 'https://galeriasce.s3-us-west-2.amazonaws.com/img-repos/' + bd + '/icono.png';

    useEffect(() => {
        getURL();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (bd !== '') {
            getPasosPreinscrip();
            getConfig();
        }
    }, [bd]) // eslint-disable-line react-hooks/exhaustive-deps

    const getConfig = async () => {
        try {
            const {data} = await axios.get(AppEnv.api + bd + '/config/all', {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            });
            setDatosAdicionales(data.datos_adicionales === '1');
            setEmaiAddres(data.email_addres_required !== undefined ? data.email_addres_required : '');
            setRequireEmail(data.datos_adicionales === '1' && data.requerir_email === '1' && data.email_addres_required !== undefined);

            if (data.school_support_status === undefined) {
                setSoporteEscuelaCheck(false)
            } else {
                setSoporteKolegiaCheck(data.school_support_status)
            }

            if (data.kolegia_support_status === undefined) {
                setSoporteKolegiaCheck(false)
            } else {
                setSoporteKolegiaCheck(data.kolegia_support_status)
            }

            if (data.number_whatsapp === undefined) {
                setNumberWhatsapp(null)
            } else {
                setNumberWhatsapp(data.number_whatsapp)
            }

            let losMedios = data.medio_enlace !== undefined ? JSON.parse(data.medio_enlace) : [];
            let losMediosV2 = [];
            if (losMedios.length !== 0 && data.canal_marketing === '1') {
                losMedios.forEach((it, i) => {
                    if (it.estatus === '1') {
                        losMediosV2.push(it);
                    }
                });
            }
            setLosMedios(losMediosV2);
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const _changeWheelState = () => {
        try {
            setVisible(!visible)
        } catch (e) {
            console.error('error => ', e)
        }
    };

    const getURL = () => {
        try {
            let bdschool = '';
            if (dataSchool.bd !== undefined) {
                bdschool = dataSchool.bd;
            }
            if (dataSchool.cct !== undefined) {
                bdschool = dataSchool.cct;
            }
            setBd(bdschool)
            setIdSchool(dataSchool.id)
            setElNivel(dataSchool.nivel);
            setNombreCiclo(dataSchool.nivel === 'PREPARATORIA' ? 'Semestre' : 'Ciclo')
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const getPasosPreinscrip = async () => {
        try {
            await setIndicator(true)
            await fetch(AppEnv.api + bd + '/get/pasos/preinscrip', {
                method: 'GET', headers: {'Content-Type': 'application/json'}
            }).then(res => res.json())
                .then(responseJson => {
                    if (responseJson.error !== undefined) {
                        alertFail();
                    } else {
                        const labels = [];
                        responseJson.forEach((itm, i) => {
                            if (itm.estatus === '1' && itm.nombre !== 'Reunion informativa' && itm.nombre !== 'Periodo de inducción') {
                                let strongLetter = <div style={{
                                    fontWeight: '400',
                                    paddingLeft: 20,
                                    paddingRight: 20,
                                    textTransform: 'uppercase'
                                }}>{itm.alias.toUpperCase()}</div>;
                                labels.push({alias: strongLetter});
                            }
                        });
                        if (labels.length === 0) {
                            confirmAlert({
                                customUI: ({onClose}) => {
                                    return customAlertResp('¡ATENCIÓN!',
                                        'La escuela tiene este proceso desactivado por el momento. Si desea más información comuníquese con la institución', 1,
                                        'Enterado', null, null,
                                        () => [window.location.reload(), onClose()], () => [onClose()]);
                                }
                            });
                            alertWarning();
                        }
                        setListSteps(labels)
                    }
                });
            setIndicator(false)
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const validarPadre = async () => {
        try {
            let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (indicator === true) {
                alertWarning('No hay información para este escuela en este momento.');
            } else if (nombre === '') {
                alertWarning('Falta ingresar nombre');
            } else if (apellido_paterno === '') {
                alertWarning('Falta ingresar apellido paterno');
            } else if (apellido_materno === '' && confApellidoMaterno === '1') {
                alertWarning('Falta ingresar apellido materno');
            } else if (!validateDni(country, curpTutor, aliasIdCiudadano)) {
            } else if (elGeneroTut === '') {
                alertWarning('Falta ingresar el género del tutor');
            } else if (numero_tel === '' || numero_tel.length < 10) {
                alertWarning('El número telefónico debe ser mínimo de 10 dígitos, capture un número telefónico válido ');
            } else if (email === '' || reg.test(email) === false) {
                alertWarning('Ingresa un e-mail válido');
            } else if (elMedio === '' && losMedios.length !== 0) {
                alertWarning('No ha seleccionado un medio de enlace');
            } else {
                if (datosAdicionales === false) {
                    await curpExistsTutor(curpTutor);
                } else {
                    await setInputsAdicionales(true)
                }
            }
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const validarPadre2 = async () => {
        try {
            let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (calle === '') {
                alertWarning('Falta ingresar calle');
            } else if (numero === '') {
                alertWarning('Falta ingresar numero');
            } else if (colonia === '') {
                alertWarning('Falta ingresar colonia');
            } else if (codigo_postal === '') {
                alertWarning('Falta ingresar código postal');
            } else if (ciudad === '') {
                alertWarning('Falta ingresar ciudad');
            } else if (estado === '') {
                alertWarning('Falta ingresar estado');
            } else {
                await curpExistsTutor(curpTutor);
            }
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const curpExistsTutor = async (curp) => {
        try {
            await setIndicatorCiclo(true)
            await setIndicatorNext(true)
            await fetch(AppEnv.apiGes + 'curp/tutor/exists', {
                method: 'POST', headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }, body: JSON.stringify({curp: curp, school_id: idSchool})
            }).then(res => res.json())
                .then(responseJson => {
                    if (responseJson.error === 'User register curp') {
                        confirmAlert({
                            customUI: ({onClose}) => {
                                return customAlertResp('¡Atención!',
                                    'La CURP que ha capturado ya se encuentra registrada en esta escuela. Capture una nueva CURP o vaya a iniciar sesión', 2,
                                    'Capturar nueva CURP', 'Ir a inicio de sesión', null,
                                    () => {
                                        setCurpTutor('');
                                        setIndicatorNext(false);
                                        setIndicatorCiclo(false);
                                        setInputsAdicionales(false);
                                        setCurpTutor('');
                                        onClose();
                                    }, () => [window.location.reload(), onClose()]);
                            }
                        });
                    } else if (responseJson.error === 'Unauthorized') {
                        confirmAlert({
                            customUI: ({onClose}) => {
                                return customAlertResp('¡Atención!',
                                    'La CURP ya está siendo utilizada en un proceso de admisión.', 2,
                                    'Capturar nueva CURP', 'Ir a inicio de sesión', null,
                                    () => {
                                        setCurpTutor('');
                                        setIndicatorNext(false);
                                        setIndicatorCiclo(false);
                                        setInputsAdicionales(false);
                                        setCurpTutor('');
                                        onClose();
                                    }, () => [window.location.reload(), onClose()]);
                            }
                        });
                    } else {
                        verificateCorreo(email);
                    }
                });
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const verificateCorreo = async (email) => {
        try {
            await fetch(AppEnv.apiGes + 'correo/tutor/exists', {
                method: 'POST', headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }, body: JSON.stringify({email: email, school_id: idSchool})
            }).then(res => res.json())
                .then(async responseJson => {
                    if (responseJson.error === 'User register mail') {
                        confirmAlert({
                            customUI: ({onClose}) => {
                                return customAlertResp('¡Atención!',
                                    'El correo que ha capturado ya se encuentra registrada en esta escuela. Capture un nuevo correo o vaya a iniciar sesión', 2,
                                    'Capturar nuevo correo', 'Ir a inicio de sesión', null,
                                    () => [
                                        setEmail(''),
                                        setIndicatorNext(false),
                                        setIndicatorCiclo(false),
                                        onClose()], () => [window.location.reload(), onClose()]);
                            }
                        });
                        // alertFail('Este e-mail ya está siendo utilizado. Por favor capture uno nuevo.');
                    } else if (responseJson.error === 'Unauthorized') {
                        confirmAlert({
                            customUI: ({onClose}) => {
                                return customAlertResp('¡Atención!',
                                    'Este e-mail ya está siendo utilizado. Por favor capture uno nuevo o continue con el proceso de admisión haciendo click en "Proceso de admisión" en la pagina de login y después en "Continuar proceso de admisión".', 2,
                                    'Capturar nuevo correo', 'Ir a inicio de sesión', null,
                                    () => [
                                        setEmail(''),
                                        setIndicatorNext(false),
                                        setIndicatorCiclo(false),
                                        onClose()], () => [window.location.reload(), onClose()]);
                            }
                        });
                        alertFail('Este e-mail ya está siendo utilizado. Por favor capture uno nuevo.');
                    } else {
                        let objectTutor = {
                            'nombre': nombre,
                            'apellido_paterno': apellido_paterno,
                            'apellido_materno': confApellidoMaterno === '1' ? apellido_materno : '',
                            'curpTutor': curpTutor,
                            'elGeneroTut': elGeneroTut,
                            'numero_tel': numero_tel,
                            'email': email,
                            'calle': calle,
                            'numero': numero,
                            'codigo_postal': codigo_postal,
                            'colonia': colonia,
                            'ciudad': ciudad,
                            'estado': estado,
                            'medio_enlace': losMedios.length !== 0 ? elMedio : ''
                        };
                        setIndicatorNext(false);
                        setAddAspirant(true);
                        setDatosTutor(objectTutor);
                        await setIndicatorCiclo(false);
                        nextData();
                    }
                });
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const nextData = async () => {
        try {
            await getCicloActual();
            await getCiclosArray('posterior');
        } catch (e) {
            console.error('error => ', e)
        }
    }

    useEffect(() => {
        if (elCiclo !== '') {
            getGrados();
        }
    }, [elCiclo])


    const getCicloActual = async () => {
        try {
            await fetch(AppEnv.api + bd + '/get/ciclo/actual', {
                method: 'GET', headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(response => response.json())
                .then(responseJson => {
                    if (responseJson.error !== undefined) {
                        alertFail();
                    } else {
                        setElCiclo(responseJson.id)
                    }
                });
        } catch (e) {
            console.error('error => ', e)
        }
    }

    // <=<●>=><=<●>=><=<●>=> Datos tutor <=<●>=><=<●>=><=<●>=>
    const inputCurpTut = async (text) => {
        try {
            await setCurpTutor(text)
            if (text.length >= 11) {
                if (text[11] === 'H') {
                    await setElGeneroTut('Masculino')
                } else {
                    await setElGeneroTut('Femenino')
                }
            }

        } catch (e) {
            console.error('error => ', e)
        }
    }

    const onChangeMedio = async (ix) => {
        try {
            await setElMedio(ix)
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const preinscrip = () => {
        try {
            let data_medio = losMedios.map((item, ix) => {
                return <option key={ix + 'materias'} value={item.nombre_medio}>{item.nombre_medio}</option>;
            });
            if (inputsAdicionales) {
                return renderDatosAdicionales()
            }
            return (
                <div className="uk-width-1-1 centerAll">
                    <Row style={{marginTop: 10}} className='uk-width-1-1 main_title centerAll'>
                        <label style={{textAlign: 'center', marginTop: 10, marginBottom: 10}}>
                            Capture la información<br/> <label className="alertPulse-css-1" style={{
                            backgroundColor: AppEnv.redColor,
                            color: AppEnv.fourthColor,
                            paddingLeft: 5,
                            paddingRight: 5
                        }}>del padre de familia o tutor legal</label>
                        </label>
                    </Row>
                    {AppEnv.tipoApp === '3' ? <Row className="uk-width-1-1" style={{
                        margin: 0,
                        padding: 0,
                        marginTop: 5,
                        marginBottom: 10,
                        color: AppEnv.redColor,
                        textAlign: 'justify'
                    }}>
                        IMPORTANTE: Asegúrese de que todos los datos que ingrese en la presente solicitud sean
                        verdaderos,
                        ya que en caso de detectar información falsa su solicitud puede ser declinada.
                    </Row> : null}
                    <div className="uk-width-1-1 section_title_two"
                         style={{color: AppEnv.fifthColor, textAlign: 'left', marginTop: 5}}>
                        Datos generales
                    </div>
                    <input className="uk-input uk-width-1-1" placeholder='Nombre(s)' style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginTop: 3,
                        marginBottom: 5,
                        textTransform: 'uppercase',
                        color: AppEnv.fifthColor
                    }} onChange={text => setNombre(text.target.value)} defaultValue={nombre}
                           autoCorrect={false}/>
                    <input className="uk-input" placeholder='Apellido paterno' style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginBottom: 5,
                        textTransform: 'uppercase',
                        color: AppEnv.fifthColor
                    }} onChange={text => setApellido_paterno(text.target.value)}
                           defaultValue={apellido_paterno} autoCorrect={false}/>
                    {confApellidoMaterno === '1' ?
                        <input className="uk-input" placeholder='Apellido Materno' style={{
                            border: '.5px solid',
                            borderColor: AppEnv.grayColorThree,
                            backgroundColor: AppEnv.grayColorOne,
                            borderRadius: 5,
                            marginBottom: 5,
                            textTransform: 'uppercase',
                            color: AppEnv.fifthColor
                        }} onChange={text => setApellido_materno(text.target.value)}
                               defaultValue={apellido_materno} autoCorrect={false}/> : null}
                    <input
                        ref={curpInput}
                        placeholder={aliasIdCiudadano}
                        maxLength={checkDniLength(country, 'maxLength')}
                        className="uk-input"
                        style={{
                            border: '.5px solid',
                            borderColor: AppEnv.grayColorThree,
                            backgroundColor: AppEnv.grayColorOne,
                            borderRadius: 5,
                            marginBottom: 5,
                            textTransform: 'uppercase',
                            color: AppEnv.fifthColor
                        }}
                        onChange={text => inputCurpTut(text.target.value)}
                        value={curpTutor}/>
                    <input
                        className="uk-input"
                        placeholder='Teléfono celular'
                        style={{
                            border: '.5px solid',
                            borderColor: AppEnv.grayColorThree,
                            backgroundColor: AppEnv.grayColorOne,
                            borderRadius: 5,
                            marginBottom: 5,
                            textTransform: 'uppercase',
                            color: AppEnv.fifthColor
                        }}
                        maxLength="10"
                        type="number"
                        name="phone"
                        onChange={(event) => {
                            const {value, maxLength} = event.target;
                            setNumero_tel(value.slice(0, maxLength))
                        }}
                        value={numero_tel}
                    />
                    <input className="uk-input" placeholder='E-mail' style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginBottom: 5,
                        color: AppEnv.fifthColor
                    }} onChange={text => setEmail(text.target.value)}
                           autoCapitalize='none' autoCorrect={false}/>
                    {losMedios.length !== 0 ?
                        <div className="uk-width-1-1 section_title_two"
                             style={{color: AppEnv.fifthColor, textAlign: 'left', marginTop: 15}}>
                            Como se enteró de la escuela
                        </div>
                        : null}
                    {losMedios.length !== 0 ? <select
                        className="uk-input" style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginBottom: 5,
                        marginTop: 3,
                        textTransform: 'uppercase',
                        textAlignLast: 'center',
                        color: AppEnv.fifthColor
                    }}
                        onChange={ix => onChangeMedio(ix.target.value)}
                    >
                        <option value="" className="centerAll">
                            Seleccione una opción
                        </option>
                        {data_medio}
                    </select> : null}
                    <Row style={{marginTop: 15, marginBottom: 20}}
                         className="centerAll uk-width-1-1">
                        {indicatorNext ?
                            <Row
                                style={{
                                    margin: 0,
                                    padding: 15,
                                    borderRadius: 6,
                                    backgroundColor: AppEnv.grayColorFive
                                }} className='uk-button uk-box-shadow-small uk-width-1-3'>
                                <Row className='uk-width-1-1 centerAll'>
                                    {pulseLoader(AppEnv.fourthColor)}
                                </Row>
                            </Row> : null}
                        {!indicatorNext ?
                            <Row
                                onClick={() => validarPadre()}
                                style={{
                                    margin: 0,
                                    padding: 15,
                                    borderRadius: 6,
                                    backgroundColor: AppEnv.secondColor
                                }} className='uk-button uk-box-shadow-small'>
                                <Row className="uk-width-1-1">
                                    <i className='fas fa-chevron-circle-right fa-1x'
                                       style={{color: AppEnv.fourthColor, marginRight: 5}}/>
                                    <label className='normal_text' style={{color: AppEnv.fourthColor}}>Continuar</label>
                                </Row>
                            </Row> : null}
                    </Row>
                </div>
            );
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const renderDatosAdicionales = () => {
        try {
            return (
                <div className="uk-width-1-1 centerAll">
                    <Row style={{marginTop: 10}} className='uk-width-1-1 main_title centerAll'>
                        <label style={{textAlign: 'center', marginTop: 10, marginBottom: 10}}>
                            Capture la información<br/> <label className="alertPulse-css-1" style={{
                            backgroundColor: AppEnv.redColor,
                            color: AppEnv.fourthColor,
                            paddingLeft: 5,
                            paddingRight: 5
                        }}>del padre de familia o tutor legal</label>
                        </label>
                    </Row>
                    {AppEnv.tipoApp === '3' ? <Row className="uk-width-1-1" style={{
                        margin: 0,
                        padding: 0,
                        marginTop: 5,
                        marginBottom: 10,
                        color: AppEnv.redColor,
                        textAlign: 'justify'
                    }}>
                        IMPORTANTE: Asegúrese de que todos los datos que ingrese en la presente solicitud sean
                        verdaderos,
                        ya que en caso de detectar información falsa su solicitud puede ser declinada.
                    </Row> : null}
                    <div className="uk-width-1-1 section_title_two"
                         style={{color: AppEnv.fifthColor, textAlign: 'left', marginTop: 5}}>
                        Datos adicionales
                    </div>
                    <input className="uk-input uk-width-1-1" placeholder='Calle' style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginTop: 3,
                        marginBottom: 5,
                        textTransform: 'uppercase',
                        color: AppEnv.fifthColor
                    }} onChange={text => setCalle(text.target.value)} value={calle}
                           autoCorrect={false}/>
                    <input className="uk-input uk-width-1-1" placeholder='Numero' maxLength={7} style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginTop: 3,
                        marginBottom: 5,
                        textTransform: 'uppercase',
                        color: AppEnv.fifthColor
                    }} onChange={text => setNumero(text.target.value)} value={numero}
                           autoCorrect={false}/>
                    <input className="uk-input uk-width-1-1" placeholder='Colonia' style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginTop: 3,
                        marginBottom: 5,
                        textTransform: 'uppercase',
                        color: AppEnv.fifthColor
                    }} onChange={text => setColonia(text.target.value)} value={colonia}
                           autoCorrect={false}/>
                    <input className="uk-input uk-width-1-1" placeholder='Código postal' maxLength={5} style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginTop: 3,
                        marginBottom: 5,
                        textTransform: 'uppercase',
                        color: AppEnv.fifthColor
                    }} onChange={text => setCodigo_postal(text.target.value)} value={codigo_postal}
                           autoCorrect={false}/>

                    <input className="uk-input uk-width-1-1" placeholder='Ciudad' style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginTop: 3,
                        marginBottom: 5,
                        textTransform: 'uppercase',
                        color: AppEnv.fifthColor
                    }} onChange={text => setCiudad(text.target.value)} value={ciudad}
                           autoCorrect={false}/>

                    <input className="uk-input uk-width-1-1" placeholder='Estado' style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginTop: 3,
                        marginBottom: 5,
                        textTransform: 'uppercase',
                        color: AppEnv.fifthColor
                    }} onChange={text => setEstado(text.target.value)} value={estado}
                           autoCorrect={false}/>

                    <Row style={{marginTop: 15, marginBottom: 20}}
                         className="centerAll uk-width-1-1">
                        {indicatorNext ?
                            <Row
                                style={{
                                    margin: 0,
                                    padding: 15,
                                    borderRadius: 6,
                                    backgroundColor: AppEnv.grayColorFive
                                }} className='uk-button uk-box-shadow-small uk-width-1-3'>
                                <Row className='uk-width-1-1 centerAll'>
                                    {pulseLoader(AppEnv.fourthColor)}
                                </Row>
                            </Row> : null}
                        {!indicatorNext ?
                            <Row
                                onClick={() => validarPadre2()}
                                style={{
                                    margin: 0,
                                    padding: 15,
                                    borderRadius: 6,
                                    backgroundColor: AppEnv.secondColor
                                }} className='uk-button uk-box-shadow-small'>
                                <Row className="uk-width-1-1">
                                    <i className='fas fa-chevron-circle-right fa-1x'
                                       style={{color: AppEnv.fourthColor, marginRight: 5}}/>
                                    <label className='normal_text' style={{color: AppEnv.fourthColor}}>Continuar</label>
                                </Row>
                            </Row> : null}
                    </Row>
                </div>
            );
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const alertPreinscrip = async () => {
        try {
            if (addAspirant === false) {
                confirmAlert({
                    customUI: ({onClose}) => {
                        return customAlertResp('¡ATENCIÓN!',
                            'Si regresa se perderá el todo el avance no guardado ¿Seguro que desea continuar?', 2,
                            'Sí', 'No', null,
                            () => [window.location.assign(AppEnv.url + '/Login'), onClose()], () => [onClose()]);
                    }
                });
            } else {
                await setAddAspirant(false)
            }
        } catch (e) {
            console.error('error => ', e)
        }
    }

    // <=<●>=><=<●>=><=<●>=> GUARDAR DATOS <=<●>=><=<●>=><=<●>=>


    const validateEscProced = () => {
        try {
            if (elNivel !== 'PREESCOLAR') {
                if (losAspirantes.escuela_procedente === undefined || losAspirantes.escuela_procedente === '') return false;
            } else {
                if (losAspirantes.tipo_alta === 'traslado') {
                    if (losAspirantes.escuela_procedente === undefined || losAspirantes.escuela_procedente === '') return false;
                }
            }
            return true;
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const validarAppellidoMat = (apellido_materno) => {
        try {
            if (apellido_materno === '' || apellido_materno === undefined) {
                return false;
            } else {
                return true;
            }
        } catch (e) {
            console.error('error => ', e)
        }
    }

    //VALIDACIONES
    const alertSolicitudEnviar = async () => {
        try {
            if (indicator === true) {
                alertWarning('No hay información para esta escuela en este momento.');
            } else if (losAspirantes.tipo_alta === '' || losAspirantes.tipo_alta === undefined) {
                alertWarning('Asegúrese de capturar todos los datos del aspirante para continuar.');
            } else if (losAspirantes.nombre_aspirante === '' || losAspirantes.nombre_aspirante === undefined) {
                alertWarning('Asegúrese de capturar el nombre del aspirante para poder continuar.');
            } else if (losAspirantes.apellido_paterno === '' || losAspirantes.apellido_paterno === undefined) {
                alertWarning('Asegúrese de capturar el apellido paterno del aspirante para poder continuar.');
            } else if (confApellidoMaterno === '1' && validarAppellidoMat(losAspirantes.apellido_materno) === false) {
                alertWarning('Asegúrese de capturar el apellido materno del aspirante para poder continuar.');
            } else if (!validateDni(country, losAspirantes.curp_aspirante, aliasIdCiudadano)) {
            } else if (losAspirantes.curp_aspirante === datosTutor.curpTutor) {
                alertWarning(aliasIdCiudadano + ' del aspirante es la misma que la' + aliasIdCiudadano + ' del tutor.');
            } else if (losAspirantes.email_aspirante === email && datosAdicionales && requireEmail) {
                alertWarning('El e-mail del aspirante deberá ser distinto al del tutor');
            } else if (datosAdicionales && (losAspirantes.identificacion_estudiante === '' || losAspirantes.identificacion_estudiante === undefined)) {
                alertWarning('Capture el NIEV del aspirante');
            } else if (losAspirantes.tipo_alta === '' || losAspirantes.tipo_alta === undefined) {
                alertWarning('Asegúrese de llenar todos los datos para agregar otro aspirante');
            } else if (losAspirantes.grado_asp === '' || losAspirantes.grado_asp === undefined || losAspirantes.grado_asp === null || losAspirantes.grado_asp === ' ') {
                alertWarning('Debe seleccionar el grado de interés del aspirante para poder continuar');
            } else if (losAspirantes.genero === '' || losAspirantes.genero === undefined) {
                alertWarning('Debe seleccionar un género del aspirante para poder continuar.');
            } else if (validateEscProced() === false) {
                alertWarning('Debe capturar la escuela de procendencia del aspirante para poder continuar.');
            } else {
                await curpExistsAspirante(losAspirantes.curp_aspirante);
            }
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const curpExistsAspirante = async (curp) => {
        try {
            setDisabledButton(true);
            await fetch(AppEnv.apiGes + 'curp/aspirante/exists', {
                method: 'POST', headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }, body: JSON.stringify({curp: curp, school_id: idSchool})
            }).then(res => res.json())
                .then(responseJson => {
                    if (responseJson.error === 'User register') {
                        confirmAlert({
                            customUI: ({onClose}) => {
                                return customAlertResp('¡Atención!',
                                    'La CURP del aspirante que ha capturado ya se encuentra registrada en la escuela. Capture un nuevo CURP o vaya a iniciar sesión y haga click sobre el boton "REGISTRARME" para darse de alta con el alumno registrado', 2,
                                    'Capturar nueva CURP', 'Ir a inicio de sesión', null,
                                    () => [clearInputCurpAsp(), onClose()], () => [window.location.reload(), onClose()]);
                            }
                        });
                    } else if (responseJson.error === 'Unauthorized') {
                        confirmAlert({
                            customUI: ({onClose}) => {
                                return customAlertResp('¡Atención!',
                                    'La CURP del aspirante que ha capturado ya ha sido utilizada en el proceso de admisión en esta escuela. Capture una nueva o continue el proceso de admisión del aspirante haciendo click en "Proceso de admisión" en la pagina de login y después en "Continuar proceso de admisión"', 2,
                                    'Capturar nueva CURP', 'Ir a inicio de sesión', null,
                                    () => [clearInputCurpAsp(), onClose()], () => [window.location.reload(), onClose()]);
                            }
                        });
                    } else {
                        createTutor();
                    }
                });
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const clearInputCurpAsp = async () => {
        try {
            losAspirantes.curp_aspirante = '';
            curpAspInput.current.value = '';
            setDisabledButton(false)
        } catch (e) {
            console.error('error => ', e)
        }
    }

    //SAVE DATOS
    const createTutor = async () => {
        try {
            await _changeWheelState();
            await fetch(AppEnv.apiGes + 'post/nuevo/tutor', {
                method: 'POST', headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }, body: JSON.stringify({
                    nombre: datosTutor.nombre.toUpperCase(),
                    apellidos: confApellidoMaterno === '1' ? datosTutor.apellido_paterno.toUpperCase() + ' ' + datosTutor.apellido_materno.toUpperCase() : datosTutor.apellido_paterno.toUpperCase(),
                    apellido_paterno: datosTutor.apellido_paterno.toUpperCase(),
                    apellido_materno: confApellidoMaterno === '1' ? datosTutor.apellido_materno.toUpperCase() : '',
                    curp: datosTutor.curpTutor.toUpperCase(),
                    genero: datosTutor.elGeneroTut,
                    telefono_contacto: datosTutor.numero_tel,
                    email: datosTutor.email,
                    calle: calle,
                    numero: numero,
                    codigo_postal: codigo_postal,
                    colonia: colonia,
                    ciudad: ciudad,
                    estado: estado,
                    password: '',
                    estatus: 'en proceso',
                    PushNotificationsID: 'asd'
                })
            }).then(res => res.json())
                .then(responseJson => {
                    if (responseJson.error !== undefined) {
                        alertFail();
                        setDisabledButton(false);
                    } else {
                        requestMultipart(responseJson.id);
                    }
                });
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const saveitem = async (key, value) => {
        try {
            await sessionStorage.setItem(key, value);
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const requestMultipart = async (id) => {
        try {
            let emailApplicant = datosAdicionales && requireEmail ? losAspirantes.email_aspirante + '@' + emailAddres : losAspirantes.curp_aspirante.toUpperCase() + '@kolegia.com';
            await fetch(AppEnv.api + bd + '/nueva/solicitud/info', {
                method: 'POST', headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }, body: JSON.stringify({
                    id_tutor: id,
                    nombre_aspirante: confApellidoMaterno === '1' ? losAspirantes.apellido_paterno.toUpperCase() + ' ' + losAspirantes.apellido_materno.toUpperCase() + ' ' + losAspirantes.nombre_aspirante.toUpperCase() : losAspirantes.apellido_paterno.toUpperCase() + ' ' + losAspirantes.nombre_aspirante.toUpperCase(),
                    nombre: losAspirantes.nombre_aspirante.toUpperCase(),
                    apellido_paterno: losAspirantes.apellido_paterno.toUpperCase(),
                    apellido_materno: confApellidoMaterno === '1' ? losAspirantes.apellido_materno.toUpperCase() : '',
                    curp_aspirante: losAspirantes.curp_aspirante.toUpperCase(),
                    email_aspirante: emailApplicant,
                    identificacion_estudiante: losAspirantes.identificacion_estudiante === '' || losAspirantes.identificacion_estudiante === undefined ? '' : losAspirantes.identificacion_estudiante.toUpperCase(),
                    genero: losAspirantes.genero,
                    grado_interes: losAspirantes.grado_asp,
                    hermanos: hermanos,
                    nivel_escolar: elNivel,
                    estado_escuela: '0',
                    escuela_procedente: losAspirantes.escuela_procedente,
                    promedio_gral: losAspirantes.promedio_gral,
                    paso_registro: '1',
                    id_registro: 'ads',
                    id_ciclo: losAspirantes.id_ciclo,
                    bd_escuela: bd,
                    fecha_cita: '',
                    hora_cita: '',
                    tipo_alta: losAspirantes.tipo_alta,
                    estatus_alta: 'en proceso',
                    paso_1: 2,
                    id_escuela: dataSchool.id,
                    codigo_postal: datosTutor.codigo_postal,
                    municipio: datosTutor.ciudad,
                    colonia: datosTutor.colonia,
                    notificacion: 'si'
                })
            }).then(res => res.json())
                .then(responseJson => {
                    if (responseJson.error !== undefined) {
                        alertFail();
                        setVisible(false);
                        setDisabledButton(false);
                    } else {
                        correoPassword(id);
                    }
                });
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const correoPassword = async (id) => {
        try {
            await saveitem('idTutor', id.toString());
            await fetch(AppEnv.api + bd + '/get/usuario/preincripcion/' + id).then(res => res.json())
                .then(responseJson => {
                    if (responseJson.error !== undefined) {
                        alertFail();
                        setVisible(false)
                    } else {
                        let title = 'Solicitud enviada';
                        let pass = <label className='section_title_two'
                                          style={{fontSize: '1.6rem', color: 'red'}}>{responseJson.pass}</label>;
                        let descrip = <Row className="uk-width-1-1 centerAll" style={{margin: 0, padding: 10}}>
                            Se ha generado su pin de acceso para el proceso de admisión. Recibirá en su correo
                            electrónico
                            una copia del mismo. Su pin es el siguiente: <br/>{pass}
                            Consérvelo en un lugar seguro o memorícelo, ya que lo ocupará para poder ingresar nuevamente
                            y
                            continuar con el proceso de admisión en el futuro.
                        </Row>;
                        confirmAlert({
                            customUI: ({onClose}) => {
                                return customAlertResp(title,
                                    descrip, 1,
                                    'Enterado', null, null,
                                    () => {
                                        setVisible(false);
                                        setDisabledButton(true);
                                        window.location.replace(AppEnv.url + '/Login');
                                        onClose()
                                    },
                                    null);
                            }
                        });
                    }
                });
        } catch (e) {
            console.error('error => ', e)
        }
    }

    // <=<●>=><=<●>=><=<●>=><=<●>=> Datos Aspirante <=<●>=><=<●>=><=<●>=><=<●>=>
    //+-+-+-+-+- Seleccion de ciclo al que va a entrar
    const getCiclosArray = async (typeArr) => {
        try {
            let level = '';
            if (elNivel === 'PREPARATORIA' || elNivel === 'BACHILLERATO') {
                level = elNivel;
            }
            await fetch(AppEnv.api + bd + '/get/ciclos/' + typeArr + '/' + level, {
                method: 'GET', headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(response => response.json())
                .then(responseJson => {
                    if (responseJson.error === null) {
                        alertFail();
                    } else {
                        let cyclesArr = [
                            {
                                title: 'Ciclo actual',
                                nombre: responseJson[0].nombre,
                                text: 'Traslado',
                                tipo: 'traslado',
                                ciclo: responseJson[0].id
                            },
                            {
                                title: 'Siguiente ciclo',
                                nombre: responseJson[1].nombre,
                                text: 'Nuevo ingreso',
                                tipo: 'ingreso',
                                ciclo: responseJson[1].id
                            }
                        ];
                        // if (moment(responseJson[0].inicio).add(60, 'days').format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD')) {
                        //     cyclesArr.push({
                        //         title: 'Siguiente ciclo',
                        //         nombre: responseJson[1].nombre,
                        //         text: 'Nuevo ingreso',
                        //         tipo: 'ingreso',
                        //         ciclo: responseJson[1].id
                        //     });
                        // }
                        // if (moment(responseJson[0].fin).subtract(30, 'days').format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD')) {
                        //     cyclesArr.splice(0, 1);
                        //     cyclesArr.push({
                        //         title: 'Siguiente ciclo',
                        //         nombre: responseJson[1].nombre,
                        //         text: 'Nuevo ingreso',
                        //         tipo: 'ingreso',
                        //         ciclo: responseJson[1].id
                        //     });
                        // }
                        setCiclosBtn(cyclesArr);
                    }
                })
        } catch (e) {
            console.error('error => ', e)
        }
    }


    useEffect(() => {
        if (ciclosBtn.length === 1) {
            changeValorAspirantes2(ciclosBtn[0].tipo, ciclosBtn[0].ciclo);
        }
    }, [ciclosBtn])

    const changeValorAspirantes2 = (tipo, ciclo) => {
        try {
            const update = {...losAspirantes, 'tipo_alta': tipo, 'id_ciclo': ciclo};
            setLosAspirantes(update);
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const rndBtnCiclo = ciclosBtn.map((itm, ix) => {
        try {
            return (
                <Row className="uk-width-1-3" style={{margin: 0, padding: 3}}>
                    <Row
                        key={ix + 'ciclosBtn'}
                        disabled={visible}
                        className="uk-width-1-1 centerAll"
                        style={{
                            borderRadius: 6,
                            padding: 4,
                            backgroundColor: losAspirantes.tipo_alta === itm.tipo ? AppEnv.mainColor : AppEnv.grayColorOne,
                            pointerEvents: disabledButton ? 'none' : null
                        }} onClick={() => {
                        changeValorAspirantes2(itm.tipo, itm.ciclo);
                        setIndexCiclo(ix)
                    }}
                    >
                        <div
                            className="uk-width-1-1"
                            style={{
                                textAlign: 'center',
                                color: losAspirantes.tipo_alta === itm.tipo ? AppEnv.fourthColor : AppEnv.fifthColor,
                                marginVertical: 3
                            }}
                        >
                            {itm.title}
                        </div>
                        <div className="uk-width-1-1" style={{
                            textAlign: 'center',
                            color: losAspirantes.tipo_alta === itm.tipo ? AppEnv.fourthColor : AppEnv.fifthColor,
                            marginBottom: 4
                        }}>
                            {itm.nombre}
                        </div>
                        <div className="uk-width-1-1" style={{
                            textAlign: 'center',
                            color: losAspirantes.tipo_alta === itm.tipo ? AppEnv.fourthColor : AppEnv.fifthColor,
                            marginBottom: 4
                        }}>
                            {itm.text}
                        </div>
                    </Row>
                </Row>
            );
        } catch (e) {
            console.error('error => ', e)
        }
    });

    //+-+-+-+-+-++-+-+-+-+-SELECTION GRADO
    const defaultGrades = (school_level) => {
        let sizeGrades = 0;
        if (school_level === 'PREESCOLAR') sizeGrades = 3;
        if (school_level === 'SECUNDARIA') sizeGrades = 3;
        if (school_level === 'PRIMARIA') sizeGrades = 6;
        if (school_level === 'BACHILLERATO' || school_level === 'PREPARATORIA') sizeGrades = 3;
        let grades = [];
        for (let i = 0; i < Array(sizeGrades).length; i++) {
            let grade = Number(i + 1);
            if (school_level === 'BACHILLERATO' || school_level === 'PREPARATORIA') {
                grade = i === 0 ? (i + 1) : (i + i + 1);
            }
            grades.push({grado: grade.toString(), alias: grade.toString(), check: 'no'});
        }
        return grades;
    }

    useEffect(() => {
        if ((elNivel === 'BACHILLERATO' || elNivel === 'PREPARATORIA') && indexCiclo !== -1) {
            const temp = {...losAspirantes, 'grado_asp': '', 'escuela_procedente': ''};
            setLosAspirantes(temp);
            let grades = [];
            let ixCycle = indexCiclo === 0 ? 2 : 1;
            for (let i = 0; i < Array(3).length; i++) {
                let grade = i === 0 ? (i + ixCycle) : (i + i + ixCycle);
                grades.push({grado: grade.toString(), alias: grade.toString(), check: 'no'});
            }
            setgrados(grades)
        }
    }, [indexCiclo])

    const getGrados = async () => {
        try {
            const {data} = await axios.get(AppEnv.api + bd + '/get/grados/' + 8);
            if (data.length !== 0) {
                setgrados(data)
            } else {
                setgrados(defaultGrades(elNivel))
            }
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const onListItemPressedGrado = async (i, gdo, id) => {
        try {
            const temp = {...losAspirantes, 'grado_asp': gdo.toString(), 'escuela_procedente': ''};
            setLosAspirantes(temp);
            // losAspirantes.grado_asp = ;
            // losAspirantes.escuela_procedente = '';
            // setIxSelectG(i);
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const rndGrados = () => {
        try {
            let buttons = [];
            grados.forEach((it, i) => {
                let smallButtonStyles = {
                    backgroundColor: losAspirantes.grado_asp === it.grado ? AppEnv.secondColor : AppEnv.grayColorOne,
                    color: losAspirantes.grado_asp === it.grado ? 'white' : AppEnv.fifthColor,
                    padding: 15,
                    borderRadius: 6,
                    paddingTop: 7,
                    paddingBottom: 7,
                    marginRight: 4,
                    marginBottom: 4
                };
                if (it.grado !== 'Todos') {
                    buttons.push(<Row className="uk-width-1-6" key={i + 'cd'} style={{margin: 0, padding: 3}}>
                        <Row className="uk-width-1-1 centerAll" disabled={visible}
                             style={smallButtonStyles}
                             onClick={() => onListItemPressedGrado(i, it.grado, it.id)}>
                            <div>
                                {it.alias !== '' && it.alias !== null && it.check === 'si' ? it.alias : it.grado}
                            </div>
                        </Row>
                    </Row>);
                }
            });
            return buttons;
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const onChangeEscuela = async (text) => {
        try {
            const temp = {...losAspirantes, 'escuela_procedente': text};
            setLosAspirantes(temp);
        } catch (e) {
            console.error('error => ', e)
        }
    }

    // //IF DON´T FOUND ESCHOOL
    // // <=<●>=><=<●>=><=<●>=> Get  <=<●>=><=<●>=><=<●>=>
    // const openModal= async (state) => {
    //     if (losAspirantes.grado_asp !== undefined && losAspirantes.grado_asp !== '') {
    //         await setModalEscuelas(state);
    //     } else {
    //         alertWarning('Seleccione un grado de interés para continuar');
    //     }
    // }
    //
    // const faltaDatos = async () => {
    //     alertWarning('Seleccione un grado de interés para continuar');
    // }

    const inputCurp = async (text) => {
        try {
            let genero = 'Masculino';
            if (text.length >= 11) {
                if (text[11] === 'H') {
                    genero = 'Masculino'
                } else {
                    genero = 'Femenino'
                }
            }
            const temp = {...losAspirantes, 'curp_aspirante': text, 'genero': genero};
            setLosAspirantes(temp);
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const califValue = async (text) => {
        try {
            let value = 0;
            if (Number(text) > 0) {
                if (Number(text) > 10) {
                    value = 10;
                } else {
                    value = Number(text)
                }
            }
            const temp = {...losAspirantes, 'promedio_gral': value};
            setLosAspirantes(temp);
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const changeValorAspirantes = (prop, value) => {
        try {
            const updated = {...losAspirantes, [prop]: value}
            setLosAspirantes(updated);
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const rndAspirante = () => {
        try {
            return (
                <Row className="uk-width-1-1 centerAll">
                    <Row style={{marginTop: 15, marginBottom: 10}}
                         className='uk-width-1-1 main_title centerAll'>
                        <div>
                            Capture los datos <label className="alertPulse-css-1" style={{
                            backgroundColor: AppEnv.redColor,
                            color: AppEnv.fourthColor,
                            paddingLeft: 5,
                            paddingRight: 5
                        }}>del aspirante</label>
                        </div>
                    </Row>
                    {AppEnv.tipoApp === '3' && elNivel === 'SECUNDARIA'
                        ? <Row className="uk-width-1-1" style={{
                            margin: 0,
                            padding: 0,
                            marginTop: 5,
                            marginBottom: 10,
                            color: AppEnv.redColor,
                            textAlign: 'justify'
                        }}>
                            IMPORTANTE: Podrán ser preinscritos a 1er grado de secundaria, de acuerdo a su edad, los
                            alumnos mayores de 12 años pero menores de 15 años que haya nacido hasta el 31 de diciembre.
                        </Row> : null}
                    {ciclosBtn.length > 1 ? <div className="uk-width-1-1 section_title_two"
                                                 style={{color: AppEnv.fifthColor, textAlign: 'left'}}>
                        Seleccione el {nombreCiclo} al cual desea aplicar el aspirante
                    </div> : <div className="uk-width-1-1 section_title_two"
                                  style={{color: AppEnv.fifthColor, textAlign: 'left'}}>
                        Se realizará el proceso de admisión para el ciclo:
                    </div>}
                    {indicatorCiclo === true && ciclosBtn.length !== 0
                        ? <Row style={{height: '9vh', cursor: 'pointer'}}
                               className='uk-width-1-1 centerAll'>
                            {pulseLoader()}
                        </Row>
                        : ciclosBtn.length > 1 ? <Row className="uk-width-1-1 centerAll"
                                                      style={{marginTop: 5, marginBottom: 5}}>
                            {rndBtnCiclo}
                        </Row> : <Row className="uk-width-1-1 centerAll">
                            <Row className="uk-width-1-1 centerAll"
                                 style={{
                                     borderRadius: 6,
                                     padding: 4,
                                     backgroundColor: AppEnv.grayColorOne
                                 }}
                            >
                                <div className="uk-width-1-1" style={{
                                    textAlign: 'center',
                                    color: AppEnv.fifthColor,
                                    marginBottom: 4,
                                    fontSize: '1rem',
                                }}>
                                    {ciclosBtn[0].title}
                                </div>
                                <div className="uk-width-1-1" style={{
                                    textAlign: 'center',
                                    color: AppEnv.fifthColor,
                                    marginBottom: 4,
                                    fontSize: '1rem',
                                }}>
                                    {ciclosBtn[0].nombre}
                                </div>
                            </Row>
                        </Row>}
                    <div className="uk-width-1-1 section_title_two"
                         style={{color: AppEnv.fifthColor, textAlign: 'left', marginTop: 5}}>
                        Complete la información
                    </div>
                    <input disabled={visible} placeholder="Nombre(s)" className="uk-input" style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginTop: 3,
                        marginBottom: 5,
                        textTransform: 'uppercase',
                        color: AppEnv.fifthColor
                    }} onChange={text => changeValorAspirantes('nombre_aspirante', text.target.value)}
                           defaultValue={losAspirantes.nombre_aspirante}/>
                    <input disabled={visible} placeholder="Apellido paterno" className="uk-input" style={{
                        border: '.5px solid',
                        borderColor: AppEnv.grayColorThree,
                        backgroundColor: AppEnv.grayColorOne,
                        borderRadius: 5,
                        marginBottom: 5,
                        textTransform: 'uppercase',
                        color: AppEnv.fifthColor
                    }} onChange={text => changeValorAspirantes('apellido_paterno', text.target.value)}
                           defaultValue={losAspirantes.apellido_paterno}
                    />
                    {confApellidoMaterno === '1'
                        ? <input disabled={visible} placeholder="Apellido materno" className="uk-input" style={{
                            border: '.5px solid',
                            borderColor: AppEnv.grayColorThree,
                            backgroundColor: AppEnv.grayColorOne,
                            borderRadius: 5,
                            marginBottom: 5,
                            textTransform: 'uppercase',
                            color: AppEnv.fifthColor
                        }} onChange={text => changeValorAspirantes('apellido_materno', text.target.value)}
                                 defaultValue={losAspirantes.apellido_materno}/>
                        : null}
                    <input
                        ref={curpAspInput}
                        disabled={visible}
                        placeholder={aliasIdCiudadano + ' del aspirante'}
                        maxLength={checkDniLength(country, 'maxLength')}
                        className="uk-input"
                        style={{
                            border: '.5px solid',
                            borderColor: AppEnv.grayColorThree,
                            backgroundColor: AppEnv.grayColorOne,
                            borderRadius: 5,
                            marginBottom: 5,
                            textTransform: 'uppercase',
                            color: AppEnv.fifthColor
                        }}
                        onChange={text => inputCurp(text.target.value)}
                        defaultValue={losAspirantes.curp_aspirante}/>
                    {requireEmail
                        ? <Row className="uk-width-1-1" style={{marginBottom: 5}}>
                            <div className="uk-width-1-1" style={{color: AppEnv.orangeColor}}>
                                *Deberá capturar el correo instucional que le proporcionó el colegio
                            </div>
                            <Row className="uk-width-1-1">
                                <Row className="uk-width-1-2" style={{margin: 0, padding: 2}}>
                                    <input className="uk-input uk-width-1-1" placeholder='E-mail' style={{
                                        border: '.5px solid',
                                        borderColor: AppEnv.grayColorThree,
                                        backgroundColor: AppEnv.grayColorOne,
                                        borderRadius: 5,
                                        color: AppEnv.fifthColor
                                    }} onChange={text => losAspirantes.email_aspirante = text.target.value}
                                           autoCapitalize='none' autoCorrect={false}
                                           defaultValue={losAspirantes.email_aspirante}/>
                                </Row>
                                <Row className="uk-width-1-2 centerAll" style={{margin: 0, padding: 2}}>
                                    <Row
                                        className="uk-input uk-width-1-1 uk-text-truncate centerAll"
                                        style={{
                                            border: '.5px solid',
                                            borderColor: AppEnv.grayColorThree,
                                            backgroundColor: AppEnv.grayColorOne,
                                            borderRadius: 5,
                                            color: AppEnv.fifthColor,
                                            // padding:5,
                                        }}
                                    >
                                        @{emailAddres}
                                    </Row>
                                </Row>
                            </Row>
                        </Row> : null}
                    {datosAdicionales ? <input
                        disabled={visible}
                        placeholder={'NIEV del aspirante'}
                        maxLength={15}
                        className="uk-input"
                        style={{
                            border: '.5px solid',
                            borderColor: AppEnv.grayColorThree,
                            backgroundColor: AppEnv.grayColorOne,
                            borderRadius: 5,
                            marginBottom: 5,
                            textTransform: 'uppercase',
                            color: AppEnv.fifthColor
                        }}
                        onChange={text => changeValorAspirantes('identificacion_estudiante', text.target.value)}
                        defaultValue={losAspirantes.identificacion_estudiante}/> : null}

                    <Row className="uk-width-1-1 centerAll">
                        <div className="uk-width-1-1 section_title_two centerAll" style={{
                            textAlign: 'left'
                        }}>
                            Seleccione un {elNivel === 'PREPARATORIA' ? 'semestre' : 'grado'} de interés
                        </div>
                        <Row className="uk-width-5-6 centerAll"
                             style={{marginTop: 5}}>{rndGrados()}</Row>
                    </Row>
                    {elNivel === 'PREESCOLAR' && losAspirantes.tipo_alta === 'ingreso' && losAspirantes.grado_asp === '1'
                        ? null
                        : <input ref={curpAspInput} disabled={visible}
                                 placeholder={'Escuela de procedencia'}
                                 maxLength={200} className="uk-input" style={{
                            border: '.5px solid',
                            borderColor: AppEnv.grayColorThree,
                            backgroundColor: AppEnv.grayColorOne,
                            borderRadius: 5,
                            marginBottom: 5,
                            textTransform: 'uppercase',
                            color: AppEnv.fifthColor
                        }} onChange={(event) => onChangeEscuela(event.target.value)}
                                 defaultValue={laEscuela}/>}
                    {elNivel === 'PREESCOLAR'
                        ? null
                        : elNivel === 'PRIMARIA' && losAspirantes.grado_asp === '1'
                            ? null
                            : <input placeholder="Último promedio general" className="uk-input" type='number' style={{
                                border: '.5px solid',
                                borderColor: AppEnv.grayColorThree,
                                backgroundColor: AppEnv.grayColorOne,
                                borderRadius: 5,
                                marginBottom: 5,
                                textTransform: 'uppercase',
                                color: AppEnv.fifthColor
                            }} maxLength={4}
                                     value={losAspirantes.promedio_gral}
                                     onChange={text => califValue(text.target.value)}/>}
                    {datosAdicionales ? <Row
                        className="uk-width-1-1"
                        style={{
                            margin: 0,
                            padding: 8,
                            borderRadius: 6,
                            backgroundColor: AppEnv.grayColorOne
                        }}
                    >
                        <Row className="uk-width-2-3">
                            <label className="uk-width-1-1" style={{textAlign: 'left'}}>
                                En caso de tener hermanos dentro del colegio favor de capturar aquí su nombre y turno
                            </label>
                        </Row>
                        <Row className="uk-width-1-3 centerAll">
                            <div
                                className="uk-width-1-1"
                                style={{
                                    padding: 5,
                                    borderRadius: 6,
                                    backgroundColor: AppEnv.secondColor,
                                    color: AppEnv.fourthColor
                                }}
                                onClick={() => setModalBrothers(true)}
                            >
                                Capturar datos
                            </div>
                        </Row>
                    </Row> : null}
                    <OwnModal
                        size={'small-modal'}
                        open={modalBrothers}
                        onClose={() => setModalBrothers(false)}
                        child={<Row className="uk-width-1-1">
                            <Row className="uk-width-1-1 main_title" style={{marginTop: 15}}>
                                Capture el nombre y turno del hermano
                            </Row>
                            <Row className="uk-width-1-1"
                                 style={{margin: 0, padding: 5, borderRadius: 6, backgroundColor: AppEnv.grayColorOne}}>
                                <Row className="uk-width-2-3 centerAll" style={{margin: 0, padding: 3}}>
                                    <input placeholder="Nombre completo" className="uk-input uk-width-1-1" style={{
                                        border: '.5px solid',
                                        borderColor: AppEnv.grayColorThree,
                                        backgroundColor: AppEnv.fourthColor,
                                        borderRadius: 5,
                                        marginBottom: 5,
                                        textTransform: 'uppercase',
                                        color: AppEnv.fifthColor
                                    }} maxLength={150}
                                           onChange={text => setNombreHermano(text.target.value)}
                                           value={nombreHermano}/>
                                </Row>
                                <Row className="uk-width-1-3" style={{margin: 0, padding: 3}}>
                                    <input placeholder="Turno" className="uk-input uk-width-1-1" style={{
                                        border: '.5px solid',
                                        borderColor: AppEnv.grayColorThree,
                                        backgroundColor: AppEnv.fourthColor,
                                        borderRadius: 5,
                                        marginBottom: 5,
                                        textTransform: 'uppercase',
                                        color: AppEnv.fifthColor
                                    }} maxLength={20}
                                           onChange={text => setTurnoHermano(text.target.value)}
                                           value={turnoHermano}/>
                                </Row>
                                <Row className="uk-width-1-1 centerAll" style={{marginTop: 5}}>
                                    <div
                                        className="uk-width-1-3"
                                        style={{
                                            padding: 5,
                                            borderRadius: 6,
                                            backgroundColor: AppEnv.mainColor,
                                            color: AppEnv.fourthColor,
                                            textAlign: 'center',
                                            fontSize: '.9rem'
                                        }}
                                        onClick={() => {
                                            if (nombreHermano === '') {
                                                alertWarning('Capture el nombre completo')
                                            } else if (turnoHermano === '') {
                                                alertWarning('Capture el turno')
                                            } else {
                                                setHermanos(hermanos => [...hermanos, {
                                                    nombre: nombreHermano,
                                                    turno: turnoHermano
                                                }]);
                                                setNombreHermano('');
                                                setTurnoHermano('')
                                            }
                                        }}
                                    >
                                        Agregar
                                    </div>
                                </Row>
                            </Row>
                            <Row className="uk-width-1-1" style={{marginTop: 10}}>
                                <Row className="uk-width-1-1 main_title">
                                    Lista de hermanos
                                </Row>
                                <Row className="uk-width-1-1" style={{marginTop: 5}}>
                                    {hermanos.length !== 0
                                        ? hermanos.map((item, i) => {
                                            return <Row className="uk-width-1-1" style={{margin: 0, padding: 4}}>
                                                <Row
                                                    className="uk-width-1-1 centerAll"
                                                    style={{
                                                        margin: 0,
                                                        padding: 8,
                                                        borderRadius: 6,
                                                        backgroundColor: AppEnv.grayColorOne
                                                    }}
                                                >
                                                    <div style={{width: '60%'}}>
                                                        <label className="uk-text-truncate uk-width-1-1"
                                                               style={{
                                                                   width: '100%',
                                                                   textAlign: 'left',
                                                                   textTransform: 'uppercase'
                                                               }}>
                                                            <b>{item.nombre}</b>
                                                        </label>
                                                    </div>
                                                    <div style={{width: '30%'}}>
                                                        <label style={{
                                                            width: '100%',
                                                            textAlign: 'center',
                                                            textTransform: 'uppercase'
                                                        }}>
                                                            {item.turno}
                                                        </label>
                                                    </div>
                                                    <div style={{width: '10%', alignItems: 'center'}}>
                                                        <div
                                                            data-uk-tooltip="Borrar"
                                                            onClick={() => {
                                                                const temp = [...hermanos];
                                                                temp.splice(i, i);
                                                                setHermanos(temp);
                                                            }}
                                                        >
                                                            <i className="fas fa-minus-circle"
                                                               style={{color: AppEnv.redColor, fontSize: '.9rem'}}/>
                                                        </div>
                                                    </div>
                                                </Row>
                                            </Row>
                                        })
                                        : <FaltaMensaje mensaje={'Sin hermanos definidos'} margin={20}/>}
                                </Row>
                            </Row>
                        </Row>}
                    >
                    </OwnModal>
                    {visible === false
                        ? <Row style={{marginTop: 15}} className="centerAll uk-width-1-1@s">
                            <button className='uk-button uk-button-default' style={{
                                padding: 10,
                                lineHeight: 1,
                                backgroundColor: AppEnv.secondColor,
                                borderRadius: 7,
                                color: AppEnv.fourthColor
                            }} onClick={() => alertSolicitudEnviar()} data-uk-tooltip='Continuar registro'>
                                <i className='fas fa-paper-plane fa-1x'
                                   style={{marginRight: 5}}/>
                                <label className='normal_text' style={{color: AppEnv.fourthColor}}>
                                    Enviar solicitud de informes
                                </label>
                            </button>
                        </Row>
                        : null}
                    {visible === true
                        ? <Row style={{marginTop: 15, marginBottom: 30}}
                               className="centerAll uk-width-1-1">
                            <Row className='uk-width-1-3' style={{
                                padding: 10,
                                lineHeight: 1,
                                backgroundColor: AppEnv.grayColorFive,
                                borderRadius: 7
                            }} data-uk-tooltip='Cargando...'>
                                <Row className='uk-width-1-1'>
                                    {pulseLoader(AppEnv.fourthColor)}
                                </Row>
                            </Row>
                        </Row> : null}
                </Row>
            );
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const setMessage = (cellphone_number) => {
        try {
            const message = 'Hola, requiero ayuda para aclaración de dudas en el proceso de admisión de Kolegia School Manager, estos son mis datos:' +
                '\nEscuela: ' + dataSchool.nombre_escuela +
                '\nNivel: ' + dataSchool.nivel +
                '\nNombre: ' + nombre + ' ' + apellido_paterno + ' ' + apellido_materno +
                '\nEmail: ' + email +
                '\nLa problemática es la siguiente: '
            whatsAppMessage(message, dataSchool.id_pais, cellphone_number)
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const renderAyuda = () => {
        try {
            return (
                <Row className='uk-width-1-1 centerAll'
                     style={{
                         backgroundColor: AppEnv.grayColorOne,
                         color: AppEnv.fifthColor,
                         borderRadius: 6,
                         padding: 0,
                         margin: 0
                     }}>

                    <Row className="uk-width-1-2 centerAll" style={{
                        margin: 0,
                        padding: 5,
                    }}>
                        <div className='main_title' style={{textAlign: 'center'}}>
                            Necesito ayuda:
                        </div>
                    </Row>
                    <Row className="uk-width-1-2 centerAll" style={{
                        margin: 0,
                        padding: '5px 0 5px 0',
                        fontSize: '0.8em',
                        fontWeight: 500,
                        color: 'white',
                    }}>
                        {soporteKolegiaCheck === '1' ?
                            <KolegiaWhatsAppButton setMessage={setMessage}/> : null}
                        {soporteEscuelaCheck === '1' ?
                            <ColegioWhatsAppButton icono={icono} setMessage={setMessage}
                                                   number={numberWhatsapp}/> : null}
                    </Row>

                </Row>
            )
        } catch (e) {
            console.error('error => ', e)
        }
    }

    return (
        <Row className="uk-width-1-1 normal_text scroll"
             style={{marginTop: 40, maxHeight: '92vh'}}>
            <Modal open={modalPdf}
                   onClose={() => setModalPdf(false)} center>
                <Col style={{
                    margin: 0,
                    padding: 15,
                    height: '60vh',
                    backgroundColor: AppEnv.fourthColor
                }} className='modalWidth centerAll normal_text'>

                </Col>
            </Modal>
            <a className='uk-link-heading' onClick={() => alertPreinscrip()}>
                <Row style={{
                    padding: 0,
                    margin: 0,
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                }} className='uk-width-1-1'>
                    <i className="fas fa-arrow-circle-left fa-1x" style={{color: 'black', fontSize: '.9rem'}}/>
                    <label className='normal_text'
                           style={{marginLeft: 10, textAlign: 'left', lineHeight: 1.25, fontSize: '.9rem'}}>
                        Atrás
                    </label>
                </Row>
            </a>
            <Row className="uk-width-1-1 centerAll">
                <Col className="uk-width-1-1 centerAll" style={{
                    margin: 0,
                    marginTop: 10,
                    borderRadius: 6,
                    padding: 0,
                    border: '1px solid',
                    backgroundColor: AppEnv.grayColorOne,
                    borderColor: AppEnv.grayColorOne,
                    overflow: 'hidden'
                }}>
                    <Row className="uk-width-1-1">
                        <Row className="uk-width-1-5"
                             style={{
                                 margin: 0,
                                 alignItems: 'center',
                                 backgroundColor: AppEnv.fourthColor,
                                 height: '65px'
                             }}>
                            <Row className="uk-width-1-1 centerAll" style={{height: '100%'}}>
                                <img
                                    style={{
                                        height: '80%',
                                        objectFit: 'contain'
                                    }}
                                    src={elLogoAdmin}
                                />
                            </Row>
                        </Row>
                        <Row className="uk-width-3-5 centerAll"
                             style={{
                                 margin: 0,
                                 alignItems: 'center',
                                 justifyContent: 'center',
                                 padding: 5,
                                 height: '65px'
                             }}>
                            <div className="uk-width-1-1">
                                <div className="uk-width-1-1" style={{textAlign: 'left'}}>
                                    Proceso de admisión para:
                                </div>
                                <div className="uk-width-1-1" style={{textAlign: 'left', marginTop: 1}}>
                                    <label
                                        className="section_title_two" style={{textTransform: 'uppercase'}}>
                                        {dataSchool.nombre_escuela}.
                                    </label>
                                </div>
                                <div className="uk-width-1-1" style={{textAlign: 'left', marginTop: 1}}>
                                    <label
                                        className="section_title_two"
                                        style={{textTransform: 'uppercase'}}>Nivel {dataSchool.conjunto_uno}.</label>
                                </div>
                            </div>
                        </Row>
                        <Row className="uk-width-1-5">
                            <Quota db={dataSchool.cct}
                                   grado_interes={losAspirantes.grado_asp !== undefined ? losAspirantes.grado_asp : '1'}/>
                        </Row>
                    </Row>
                </Col>
            </Row>

            {listSteps.length > 0 ? <CurrentStepCard labelStep={listSteps}/> :
                <NoAdmissionProcess/>}
            {soporteEscuelaCheck === '1' || soporteKolegiaCheck === '1' ? renderAyuda() : null}
            {listSteps.length !== 0 ? addAspirant === false ? preinscrip() : null : null}
            {listSteps.length !== 0 ? addAspirant === true ? rndAspirante() : null : null}
        </Row>
    );
}

const KolegiaWhatsAppButton = ({setMessage, number}) => {
    try {
        return (
            <Row className="uk-width-1-2 centerAll" style={{margin: 0, padding: 3}}>
                <Row onClick={() => setMessage(AppEnv.celular_soporte)}
                     data-uk-tooltip='Soporte Kolegia'
                     className="uk-width-1-1 centerAll"
                     style={{
                         backgroundColor: AppEnv.kolegiaBlue,
                         borderRadius: 6,
                         padding: 4,
                         cursor: 'pointer',
                         margin: 0
                     }}>
                    <Row className={'uk-width-1-1 centerAll'}
                         style={{margin: 0, padding: '0px .5em'}}>
                        <Row className='uk-width-1-3@s centerAll'
                             style={{textAlign: 'center'}}>
                            <img src={'/images/imagogris.png'} width='20px'/>
                        </Row>
                        <Row className='uk-width-2-3@s centerAll '
                             style={{
                                 margin: 0,
                                 padding: 0,
                                 justifyContent: 'center',
                                 alignItems: 'center',
                                 textAlign: 'center'
                             }}>
                            Soporte
                        </Row>
                    </Row>
                </Row>
            </Row>
        )
    } catch (e) {
        console.error('error => ', e)
    }
}

const ColegioWhatsAppButton = ({icono, number, setMessage}) => {
    try {
        return (
            <Row className="uk-width-1-2 centerAll" style={{margin: 0, padding: 3}}>
                <Row onClick={() => setMessage(number)}
                     data-uk-tooltip='Soporte Colegio'
                     className="uk-width-1-1 centerAll"
                     style={{
                         border: '1px solid ' + AppEnv.greenColor,
                         background: AppEnv.fourthColor,
                         borderRadius: 6,
                         padding: 4,
                         cursor: 'pointer',
                         margin: 0,
                     }}>
                    <Row className={'uk-width-1-1 centerAll'}
                         style={{margin: 0, padding: '0px .5em'}}>
                        <Row className='uk-width-1-3@s centerAll'
                             style={{
                                 margin: 0,
                                 padding: 0,
                                 textAlign: 'center'
                             }}>
                            <img src={icono} width='20px'/>
                        </Row>
                        <Row className='uk-width-2-3@s centerAll'
                             style={{
                                 margin: 0,
                                 padding: 0,
                                 color: AppEnv.fifthColor,
                                 justifyContent: 'center',
                                 alignItems: 'center',
                                 textAlign: 'center'
                             }}>
                            Soporte
                        </Row>
                    </Row>
                </Row>
            </Row>
        )
    } catch (e) {
        console.error('error => ', e)
    }
}

const CurrentStepCard = ({labelStep}) => {
    try {
        return (
            <Row className="uk-width-1-1 centerAll" style={{margin: '0 0 10px 0', padding: 0}}>
                <Col className="uk-width-1-1 centerAll" style={{
                    margin: 0,
                    marginTop: 10,
                    borderRadius: 6,
                    padding: 0,
                    border: '1px solid',
                    backgroundColor: AppEnv.grayColorOne,
                    borderColor: AppEnv.grayColorOne,
                    overflow: 'hidden'
                }}>
                    <Row className="uk-width-1-1">
                        <Row className="uk-width-1-5"
                             style={{
                                 margin: 0,
                                 alignItems: 'center',
                                 backgroundColor: AppEnv.fourthColor,
                                 height: '8vh'
                             }}>
                            <Col className="uk-width-1-1 centerAll" style={{
                                margin: 0,
                                padding: 5,
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column'
                            }}>
                                <Row className="uk-width-1-1 centerAll" style={{flex: 10}}>
                                    <i className="fas fa-tasks"
                                       style={{color: AppEnv.fifthColor, fontSize: '1.8rem'}}/>
                                </Row>
                                <Row className="uk-width-1-1 centerAll" style={{flex: 1}}>

                                </Row>
                            </Col>
                        </Row>
                        <Col className="uk-width-4-5 centerH"
                             style={{margin: 0, padding: 5, height: '8vh', display: 'flex', flexDirection: 'column'}}>
                            <Row className="uk-width-1-1 module_title"
                                 style={{color: '#292929', fontSize: '23px'}}>
                                Paso 1 de {labelStep.length}
                            </Row>
                            <Row className="uk-width-1-1">
                                {labelStep.length > 0 ? labelStep[0].nombre : null}
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    } catch (e) {
        console.error('error => ', e)
    }
}

const NoAdmissionProcess = () => {
    try {
        return (
            <div style={{
                color: AppEnv.grayColorFive,
                textAlign: 'center',
                paddingHorizontal: 20,
                top: 20
            }}>
                Sin proceso de admisión
                <div style={{
                    color: AppEnv.grayColorFive,
                    textAlign: 'center',
                    marginTop: 10
                }}>Esta escuela tiene desactivado el proceso de admisiones, comuníquese
                    directamente
                    con las instalaciones de la institución </div>
            </div>
        )
    } catch (e) {
        console.error('error => ', e)
    }
}

const Quota = (bd) => {

    const {globalConfiguration, fetchGlobalConfiguration} = React.useContext(GlobalConfigurationContext)
    const [aspirantes, setAspirantes] = React.useState([])

    React.useEffect(() => {
        if (!globalConfiguration) fetchGlobalConfiguration(bd)
        getPreinscritos()
    }, [])

    const getPreinscritos = async () => {
        try {
            const response = await axios.get(AppEnv.api + bd.db + '/get/ciclo/siguiente')
            const {data} = await axios.get(AppEnv.api + bd.db + '/get/aspirantes/alta/' + response.data.id + '/' + bd.grado_interes)
            setAspirantes(data)
        } catch (e) {
            console.error('error => ', e)
        }
    }

    const getStatistics = () => {
        if (!globalConfiguration.grados_limite_status || globalConfiguration.grados_limite_status === '0') {

        } else if (!globalConfiguration.grados_config) {

        } else {
            const gradosConfig = JSON.parse(globalConfiguration.grados_config)
            return (Object.keys(gradosConfig).reduce((accumulator, item) => {
                return accumulator + Number(gradosConfig[item])
            }, 0) - (aspirantes.filter(aspirante => aspirante.user_id)).length) + '/' + Object.keys(gradosConfig).reduce((accumulator, item) => {
                return accumulator + Number(gradosConfig[item])
            }, 0)
        }
    }

    const getColors = () => {
        if (!globalConfiguration) {
            return {background: AppEnv.grayColorOne, color: 'black'}
        } else {
            if (!globalConfiguration.grados_limite_status || globalConfiguration.grados_limite_status === '0') {
                return {background: AppEnv.grayColorOne, color: 'black'}
            } else if (!globalConfiguration.grados_config) {
                return {background: AppEnv.grayColorOne, color: 'black'}
            } else {
                if (globalConfiguration) {
                    const gradosConfig = JSON.parse(globalConfiguration.grados_config)
                    const percentage = (Object.keys(gradosConfig).reduce((accumulator, item) => {
                        return accumulator + Number(gradosConfig[item])
                    }, 0) - (aspirantes.filter(aspirante => aspirante.user_id)).length) / Object.keys(gradosConfig).reduce((accumulator, item) => {
                        return accumulator + Number(gradosConfig[item])
                    }, 0) * 100
                    if (percentage === 0) {
                        return {background: AppEnv.secondColor, color: 'white'}
                    } else if (percentage <= 33) {
                        return {background: AppEnv.orangeColorTwo, color: 'white'}
                    } else if (percentage <= 66) {
                        return {background: AppEnv.yellowColor, color: 'black'}
                    } else {
                        return {background: AppEnv.greenColorTwo, color: 'white'}
                    }
                } else {
                    return {background: 'white', color: 'black'}
                }
            }
        }
    }

    return (
        <Row className="uk-width-1-1 centerAll" style={{
            margin: 0,
            alignItems: 'center',
            height: '60px',
            ...getColors()
        }}>
            <div className="uk-width-1-1 centerAll" style={{fontSize: '0.68rem'}}>
                {globalConfiguration ? !globalConfiguration.grados_limite_status || globalConfiguration.grados_limite_status === '0' ? null : 'Lugares disponibles:' : null}
            </div>
            <div className={"uk-width-1-1"} style={{fontSize: '1.1rem', fontWeight: 600}}>
                {globalConfiguration ? getStatistics() : '0/0'}
            </div>
        </Row>

    )
}



